import { Grid2 as Grid, Skeleton } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { useIntersectionRenderer } from "@sinch/components/IntersectionRenderer/IntersectionRendererProvider";

export const IntersectionRenderer: FC<PropsWithChildren> = ({ children }) => {
  const { containerRef, visible } = useIntersectionRenderer();

  return (
    <div ref={containerRef} style={{ display: "inherit", height: "100%" }}>
      {visible ? children : <TreeItemContentPlaceholder />}
    </div>
  );
};

const TreeItemContentPlaceholder = () => (
  <Grid container spacing={1} sx={{ height: "100%" }}>
    <Grid size="grow">
      <Skeleton height="100%" variant="rounded" width="100%"></Skeleton>
    </Grid>
    <Grid size={3}>
      <Skeleton height="100%" variant="rounded" width="100%"></Skeleton>
    </Grid>
    <Grid size={2} sx={{ minWidth: 200 }}>
      <Skeleton height="100%" variant="rounded" width="100%"></Skeleton>
    </Grid>
    <Grid size={2} sx={{ minWidth: 200 }}>
      <Skeleton height="100%" variant="rounded" width="100%"></Skeleton>
    </Grid>
    <Grid size="auto" sx={{ minWidth: 36 }}></Grid>
  </Grid>
);
